/* tslint:disable */
export const en_overrides_strings: Record<string, string> = {
  'AddressLine1': 'Address line 1',
  'AddressLine2': 'Address line 2',
  'AddressLine3': 'Address line 3',
  'afterAndUntil': 'Your appointment is scheduled for <b><u>{bookingDate}</u></b> at <b><u>{bookingPlace}</u></b>.',
  'all.reviews': 'All reviews for this document application',
  'BirthDay': 'Date of birth',
  'divers.data.DYN.': 'Demand details',
  'err.OtherName.required': 'Other name is required',
  'err.paymentMethod.required': 'Payment method is required',
  'err.summary.accept.all': 'You must accept all statements by checking the corresponding boxes before proceeding with your application.',
  'form.password2': 'Confirm your password',
  'global.connect': 'Log in',
  'kiosk.standby.text1': 'Start by filling out your document application in just a few clicks on this tablet or online.',
  'MaidenName': 'Maiden name',
  'payment_status.desc.DYN.2.outFinish': 'This application has been completed. The passport has been issued.',
  'payment_status.DYN.6.finalReview': 'Pending verification',
  'Payment.print': 'Payment',
  'Payment.validated': 'To be paid',
  'payOnArrival': 'I acknowledge that payment on site is mandatory',
  'pending.desc': 'This document application is currently awaiting correction from the customer.',
  'pending.review.desc': 'A correction of this document application has been requested to the applicant on the {date} by the user',
  'printEvent.desc': 'This application has been printed with all of its documents the {date} by the user',
  'refusal.review.desc': 'This application has been reviewed as refused the {date} by the user',
  'refusalReason.desc.DYN.': '<p>Please provide a brief description of the refusal reason.</p>',
  'RenewDocument': 'Are you applying to renew this document?',
  'RenewDocumentFile': 'Previous document (renewal proof)',
  'SHOWCASE.COMMON.ALL_RIGHTS': 'All rights reserved.',
  'SHOWCASE.COMMON.GET_EVISA': 'Start My Application',
  'SHOWCASE.COMMON.LEARN_MORE': 'Learn More',
  'showcase.ctaSubtitle': 'One portal. All your official documents — {docs} — applied for, tracked and collected in person.',
  'showcase.ctaTitle': 'Your documents,<br/><em>online.</em>',
  'showcase.flowSubtitle': '{name} guides you through each stage of your document request, so you always know where you stand and what comes next.',
  'showcase.flowTitleMain': 'Four steps.<br/><em>One portal.</em>',
  'showcase.flowTitleSub': 'Your document request, handled digitally.',
  'showcase.heroCta1': 'Start application',
  'showcase.heroCta2': 'Track my request',
  'showcase.heroSubtitle': 'Fill your application for a passport, national ID or residence permit online. {name} processes and tracks every request in real time, from submission to delivery.',
  'showcase.heroTitle': 'Your documents,<br/><em>processed digitally.</em>',
  'showcase.portalType': 'Document services portal',
  'showcase.step4.paneDesc': 'Your document is processed and ready for collection…',
  'showcase.step4.paneTitle': 'Ready for collection',
  'showcase.tl.step1': 'Personal info',
  'showcase.tl.step3': 'Review',
  'showcase.tl.step4': 'Issued',
  'sinceOneWeek': 'Please note that this document application has been in awaiting review status for more than one week.',
  'summary.accept.conditions': 'Please read and accept the following statements by checking the corresponding boxes.',
  'summary.bankTransfer': '<strong>Important:</strong> Payment instructions will be sent to you by email.',
  'timeslot.notAvailable': 'No active missions',
  'tooltip.allReviews': 'All the reviews of this document application, with the date and the user who made the review.',
  'tooltip.approve': 'Approve this document application as a final decision. You can also add a comment. If the term "blacklisted" is present, the person will be blacklisted.',
  'tooltip.entryRegister': 'Manually register an entry without a document for a person.',
  'tooltip.exitRegister': 'Manually register an exit without a document for a person.',
  'tooltip.paymentType': 'The type of payment for this document application.',
  'tooltip.refuse': 'Refuse this document application as a final decision. You can also add a comment.',
  'tooltip.review': 'Review this document application as approved or refused and add a comment.',
  'tooltip.revision': 'Ask the client to correct the document application.',
  'validate.desc': 'This document application was approved on {date} by the user'
};
